<template>
  <filters @filters-updated="onFiltersUpdated"></filters>
  <div class="showcases mt-5">
<!--    <h3 v-if="posts.length" class="mb-4" v-html="projectCount()"></h3>-->
    <div class="row" v-if="posts.length">
      <div class="col-sm-6 col-lg-4" v-for="showcase in posts">
        <showcase :showcase="showcase" @filters-updated="onFiltersUpdated"></showcase>
      </div>
    </div>
    <div class="d-flex justify-content-center" v-if="posts.length && hasMorePosts">
      <button class="btn btn-lg btn-outline-dark" @click="nextPage">Load more</button>
    </div>
    <div v-if="loading" class="showcases__loading">
      <showcase-placeholders></showcase-placeholders>
    </div>
    <div v-if="loaded && !posts.length" class="text-center bg-warning bg-gradient p-2">No results.</div>
  </div>
</template>

<script>
import Filters from "../components/Filters";
import Showcase from "../components/Showcase";
import ShowcasePlaceholders from "../components/ShowcasePlaceholders";

export default {
  components: {
    Filters,
    Showcase,
    ShowcasePlaceholders
  },
  data() {
    return {
      filters: {},
      posts: [],
      loading: false,
      loaded: false,
      hasMorePosts: true,
      error: '',
      perPage: 51,
      page: 1
    };
  },
  created() {
    this.loading = true;
  },
  methods: {
    onFiltersUpdated(filters) {
      this.loaded = false;
      this.loading = true;
      this.posts = [];
      this.page = 1;
      this.hasMorePosts = true;
      this.filters = filters;
      this.fetchData();
    },
    nextPage() {
      this.page++;
      this.fetchData();
    },
    projectCount() {
      return this.posts.length + (this.posts.length === 1 ? " project" : " projects");
    },
    fetchData() {
      try {
        const that = this;
        let params = {
          ...{
            '_embed': '',
            'per_page': this.perPage,
            'page': this.page
          },
          ...this.filters
        };
        axios.get("/wp-json/wp/v2/posts", { params: params })
            .then(function(response) {

              if (response.data.length > 0) {
                that.posts.push(...response.data);
              }
              else {
                that.hasMorePosts = false;
              }

              if (that.posts.length < (that.perPage * that.page)) {
                that.hasMorePosts = false;
              }

              that.loaded = true;
              that.loading = false;

              that.error = '';

            });
      }
      catch(error) {
        this.error = 'Data could not be loaded.';
      }
    }
  }
}
</script>
